import { createContext, useContext, useState } from 'react';

const TimeMachineContext = createContext();

export const TimeMachineProvider = ({ children }) => {
  const [timeMachineMode, setTimeMachineMode] = useState(false);

  return (
    <TimeMachineContext.Provider value={{ timeMachineMode, setTimeMachineMode }}>
      {children}
    </TimeMachineContext.Provider>
  );
};

export const useTimeMachine = () => {
  const context = useContext(TimeMachineContext);
  if (!context) {
    throw new Error('useTimeMachine must be used within a TimeMachineProvider');
  }
  return context;
};

